/* tslint:disable */
import {
  App,
  Entity
} from '../index';

declare var Object: any;
export interface EntityformulaInterface {
  name: string;
  formula: string;
  condition?: string;
  sortorder?: number;
  fields?: Array<string>;
  results?: Array<string>;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
}

export class Entityformula implements EntityformulaInterface {
  name: string;
  formula: string;
  condition: string;
  sortorder: number;
  fields: Array<string>;
  results: Array<string>;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  constructor(data?: EntityformulaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entityformula`.
   */
  public static getModelName() {
    return "Entityformula";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entityformula for dynamic purposes.
  **/
  public static factory(data: EntityformulaInterface): Entityformula{
    return new Entityformula(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entityformula',
      plural: 'entityformulae',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        formula: {
          name: 'formula',
          type: 'string'
        },
        condition: {
          name: 'condition',
          type: 'string'
        },
        sortorder: {
          name: 'sortorder',
          type: 'number'
        },
        fields: {
          name: 'fields',
          type: 'Array&lt;string&gt;'
        },
        results: {
          name: 'results',
          type: 'Array&lt;string&gt;'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entityformula.ts